

import { connect } from 'react-redux';
import NewsHomeComponent from '../components/NewsHomeComponent';
import {
    getNewsHomeDataIfNeeded, getNewsDataIfNeeded, countNewsView,
} from '../actions/NewsActions';

const mapStateToProps = (state) => ({
    newsHomeData: state.news.newsHomeData,
    pinnedRightColumnNews: state.news.pinnedRightColumnNews,
    breakpointReducer: state.breakpointReducer,
    reutersNewsData: state.news.newsPageData,
    isPro: state.profile.user.isPro,
    profileInitialized: state.profile.profileInitialized,
});

const mapDispatchToProps = (dispatch) => ({
    getNewsHomeDataIfNeeded: () => {
        dispatch(getNewsHomeDataIfNeeded());
    },
    countNewsView: (newsViews) => {
        dispatch(countNewsView(newsViews));
    },
    getNewsDataIfNeeded: (qtdNews, qtdInit) => {
        dispatch(getNewsDataIfNeeded(qtdNews, qtdInit));
    },
});

const NewsContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(NewsHomeComponent);

export default NewsContainer;
